import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewDataDictionary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.DataDictionary = null;

        if (this.props.DataDictionary){
            this.data.DataDictionary = this.props.DataDictionary; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.DataDictionary){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th><PD.Td><PD.PdNavLink to={"/datadictionary/" + json._id} > {json.name}</PD.PdNavLink></PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'namespace') &&
                            <PD.Tr>                                
                                <PD.Th>Namespace</PD.Th><PD.Td>{json.namespace}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'prefix') &&
                            <PD.Tr>                                
                                <PD.Th>Default Prefix</PD.Th><PD.Td>{json.prefix}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.DataDictionary)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewDataDictionary;